import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opacity-50 text-sm" }
const _hoisted_2 = {
  key: 1,
  class: "ml-auto"
}

import Spinner from '@/components/Spinner.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { formatNumbersMixin } from '@/mixins/format-numbers.mixin';
import { Token } from '@/sdk/entities/token';
import BigNumber from 'bignumber.js';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenPanel',
  props: {
    token: null,
    balance: null,
    hideZeroBalance: { type: Boolean },
    isWalletInjected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  token: Token;
  balance: BigNumber | null;
  hideZeroBalance: boolean;
  isWalletInjected: boolean;
}


const { format } = formatNumbersMixin.methods;
const hideTokenPanel = computed(() => props.hideZeroBalance && props.balance?.eq('0'));

return (_ctx: any,_cache: any) => {
  return (!_unref(hideTokenPanel))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "token-panel w-full justify-content-start text-left clickable",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
      }, [
        (__props.token)
          ? (_openBlock(), _createBlock(TokenIcon, {
              key: 0,
              "icon-src": __props.token.tokenIconUrl,
              symbol: __props.token.symbol,
              class: "mr-2"
            }, null, 8, ["icon-src", "symbol"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, _toDisplayString(__props.token.unwrapWETH().symbol), 1),
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.token.unwrapWETH().name), 1)
        ]),
        (__props.isWalletInjected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (__props.balance === null)
                ? (_openBlock(), _createBlock(Spinner, {
                    key: 0,
                    color: "white"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(format)(__props.balance)), 1)
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})